"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserFunctions = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_query_1 = require("@tanstack/react-query");
var usePariluxAPI_1 = (0, tslib_1.__importDefault)(require("./usePariluxAPI"));
var constants_1 = require("../constants");
var useUserFunctions = function () {
    var request = (0, usePariluxAPI_1.default)('FOSData').request;
    var fetchUserFunctions = (0, react_1.useCallback)(function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var data;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request({
                        url: "/Users/MyUserFunctions",
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    }); }, [request]);
    return (0, react_query_1.useQuery)([constants_1.USER_FUNCTIONS_KEY], fetchUserFunctions, {
        staleTime: 8 * 60 * 60 * 1000,
    });
};
exports.useUserFunctions = useUserFunctions;
